import { render, staticRenderFns } from "./PatOrganizer.vue?vue&type=template&id=70606952&scoped=true"
import script from "./PatOrganizer.vue?vue&type=script&lang=js"
export * from "./PatOrganizer.vue?vue&type=script&lang=js"
import style0 from "./PatOrganizer.vue?vue&type=style&index=0&id=70606952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70606952",
  null
  
)

export default component.exports